import { ChargeZem } from '../../../components/service/accounts/charge';
export const ChargePageView = () => {
  return <ChargeZem data-sentry-element="ChargeZem" data-sentry-component="ChargePageView" data-sentry-source-file="charge.tsx" />;
};